import React from 'react'
import { useColorMode } from 'theme-ui'
import { getImage } from 'gatsby-plugin-image'
import Logo from '../../components/Logo/index'
import useSiteMetadata from '../../helpers/useSiteMetadata'
import useLogo from '../../helpers/useLogo'

export const HeaderLogo = ({ ...props }) => {
  const { title } = useSiteMetadata()
  const { logo, logoDark } = useLogo()

  const [colorMode] = useColorMode()
  const isDark = colorMode === `dark`

  const logoNormal = getImage(logo)
  const LogoDark = getImage(logoDark)

  if (!logoNormal) return null

  return isDark && LogoDark ? (
    <Logo image={LogoDark} title={title} alt={title} {...props}/>
  ) : (
    <Logo image={logoNormal} title={title} alt={title} {...props} />
  )
}